import React, { Fragment,useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import { useForm } from "react-hook-form"
import { Button } from 'reactstrap';

// import useRazorpay from 'react-razorpay';

const CheckoutPage = (props) => {
      const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm()

    // const Razorpay = useRazorpay();

    const pack = JSON.parse(localStorage.getItem('package'));
    const [price, setPrice] = React.useState(pack.pack_price);
    const [gst, setGst] = React.useState(price * 0.18);
    const [total, setTotal] = React.useState(pack.pack_price);
    const [emailCheck, setEmailCheck] = React.useState(false);
    const [phoneCheck, setPhoneCheck] = React.useState(false);

    const [country, setCountry] = React.useState([]);
    const [state, setState] = React.useState([]);
    const [city, setCity] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const createOrder = async (data) => {
        
        let response = await fetch('https://api.easemyhotel.io/api/pay/order_create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: data.name,
                phone: data.phone,
                email: data.email,
                company: data.company,
                gst_no: data.gst_no,
                address: data.address,
                country: data.country,
                state: data.state,
                city: data.city,
                amount: total,
                package_id: pack.pack_id,
                package_type: data.type ? data.type : 1, 
                package_price: price,
                package_gst: gst,
                package_total: total + gst,
            }),
        });
        
        let res = await response.json()
        if(res.code == 101) {
            if(res.field == 'email') {
                setEmailCheck(true);
            }
            if(res.field == 'phone') {
                setPhoneCheck(true);
            }
        }
        return res;
    }

    const onSubmit = async (data) => {
        console.log(data);
        setLoading(true);
        let ord = await createOrder(data);

        if(pack.pack_price == 0) {
            if(ord.code == 200 && ord.status == 'success') {
                window.location.href = '/success';
            } else {
                setLoading(false);
            }
        } else {
            
            // console.log(ord);
            let options = {
                key: 'rzp_live_TnHBin6Js6dAyL', // Enter the Key ID generated from the Dashboard
                amount: total + gst, // Amount is in currency subunits. Default currency is INR.
                currency: 'INR',
                name: 'EaseMyHotel',
                description: 'Package Payment',
                order_id: ord.order_id, //This is a sample Order ID. Pass the `order_id` obtained in the response of Step 1
                handler: function (response) {
                    // Handle the payment success response
                    console.log(response);
                    fetch('https://api.easemyhotel.io/api/pay/verify', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature,
                            package_id: pack.pack_id,
                        }),
                    })
                    .then(res => res.json())
                    .then(resData => {
                        if(resData.code == 200) {
                            window.location.href = '/success';
                        } 
                    })
                    .catch(err => console.error('Verification Error:', err));
                },
                prefill: {
                    name: data.name,
                    email: data.email,
                    contact: data.phone,
                },
                theme: {
                    color: '#3399cc',
                },
            };
            if(ord.code == 200) {
                options.modal = {
                    ondismiss: function() {
                        setLoading(false);
                    }
                };
                const rzpay = new window.Razorpay(options);
                rzpay.open();
            } else {
                setLoading(false);
            }
        }
    
    }

    const getCountry = () => {
        fetch('https://api.easemyhotel.io/api/countries')
            .then(response => response.json())
            .then(data => {
                if(data.code == 200) {
                    setCountry(data.data);
                } 
            })
            .catch(error => console.error('Error fetching countries:', error));
    }

    const getState = (countryId) => {
        fetch(`https://api.easemyhotel.io/api/states/${countryId}`)
            .then(response => response.json())
            .then(data => {
                if(data.code == 200) {
                    setState(data.data);
                }
            })
        }

    const getCity = (stateId) => {
        fetch(`https://api.easemyhotel.io/api/cities/${stateId}`)
            .then(response => response.json())
            .then(data => {
                if(data.code == 200) {
                    setCity(data.data);
                }
            })
    }

    useEffect(() => {
        // Dynamically add Razorpay script
        const script = document.createElement('script');
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
        
        getCountry();
        // Optional: Cleanup script on unmount
        return () => {
            document.body.removeChild(script);
        };

    }, []);
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>Checkout</h1>
                                </div>
                            </div>
                        </div>
                </section>
                <section className="privacy_policy_section section_space pt-0">
                    <div className="container">
                    <form className="checkout_form_field row" onSubmit={handleSubmit(onSubmit)}>    
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="checkout_form_div">
                                    <h2 style={{color:'#9769FF'}}>Billing Information {pack.id}</h2>
                                    <p>All fields required unless otherwise stated.</p>

                                        <div className="form-group col-lg-12">
                                            <input type="text" placeholder="Full Name" name='name' 
                                            className="form-control"
                                            {...register("name", { required: true })}
                                            />
                                            {errors.name && <span className='text-danger'>Full Name is required</span>}
                                        </div>
                                        <div className="form-group col-lg-12">
                                            <input type="text" placeholder="Phone Number" name='phone' 
                                            className="form-control"
                                            {...register("phone", { 
                                                required: 'Phone Number is required',
                                                pattern: {
                                                    value: /^[0-9]{10}$/,
                                                    message: "Invalid phone number"
                                                },

                                             })}
                                             onChange={()=>{
                                                setPhoneCheck(false)
                                             }}
                                        />
                                        {errors.phone && <span className='text-danger'>{errors.phone.message}</span>}
                                        {phoneCheck && <span className='text-danger'>Mobile Number already registered.</span>}
                                        </div>
                                        <div className="form-group col-lg-12">
                                            <input type="email" placeholder="Email Address"  name='email' 
                                            className="form-control"
                                            {...register("email", {
                                                required: 'Email is required',
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: "Invalid email address"
                                                }
                                            })}
                                            onChange={()=> {setEmailCheck(false)}}
                                            
                                            />
                                            {errors.email && <span className='text-danger'>{errors.email.message} </span>}
                                            {emailCheck && <span className='text-danger'>Email already registered.</span>}
                                        </div>

                                        <div className="form-group col-lg-12">
                                            <input type="text" placeholder="Business Name"  name='company' 
                                            className="form-control"
                                            {...register("company", {
                                                required: 'Business Name is required',
                                            })}
                                            
                                            />
                                            {errors.company
                                            
                                             && <span className='text-danger'>{errors.company.message}</span>}
                                        </div>

                                        <div className="form-group col-lg-12">
                                            <input type="text" placeholder="Business GST No."  name='gst_no' 
                                            className="form-control"
                                            {...register("gst_no", {
                                                required: 'GST Number is required',
                                            })}
                                            
                                            />
                                            {errors.gst_no && <span className='text-danger'>{errors.gst_no.message}</span>}
                                        </div>

                                         <div className="form-group col-lg-12">
                                            <input type="text" placeholder="Address."  name='address' 
                                            className="form-control"
                                            {...register("address", {
                                                required: 'Address is required',
                                            })}
                                            
                                            />
                                            {errors.address && <span className='text-danger'>{errors.address.message}</span>}
                                        </div>

                                          <div className="form-group col-lg-12">
                                            <select className="form-select" name='country'
                                                {...register("country", {
                                                     required: true,
                                                     onChange: (e) => {
                                                        setState([]);
                                                        setCity([]);
                                                        getState(e.target.value);
                                                    }
                                                })}
                                            >
                                                <option value="">Select Country</option>
                                               {country.map((item, index) => (
                                                    <option key={index} value={item.value}>{item.label}</option>
                                               ))}
                                            </select>
                                            {errors.country && <span className='text-danger'>Country is required</span>}
                                        </div>
                                        <div className="form-group col-lg-12">
                                            <select className="form-select" name='state'
                                                {...register("state", { 
                                                    required: true,
                                                    onChange: (e) => {
                                                        setCity([]);
                                                        getCity(e.target.value);
                                                    }
                                                 })}
                                            >
                                                <option value="">Select State</option>
                                               {state.map((item, index) => (
                                                    <option key={index} value={item.value}>{item.label}</option>
                                               ))}
                                            </select>
                                            {errors.state && <span className='text-danger'>State is required</span>}
                                        </div>

                                        <div className="form-group col-lg-12">
                                            <select className="form-select" name='city'
                                              
                                                {...register("city", { required: true })}
                                            >
                                                <option value="">Select City</option>
                                               {city.map((item, index) => (
                                                    <option key={index} value={item.value}>{item.label}</option>
                                               ))}
                                            </select>
                                            {errors.city && <span className='text-danger'>City is required</span>}
                                        </div>
{/* 

                                        <div className="form-group col-lg-12">
                                            <Button type='submit' className='conatc_btn' style={{width:'100%', textAlign:"center" }} >Submit</Button>
                                        </div>
                                     */}

                                </div>
                            </div>
                                    

                            <div className="col-lg-5 offset-1">
                                <div className='checkout_form_inside checkout_form'>
                                    <h3 style={{marginBottom:"20px"}}>Order Summary</h3>
                                    <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-8'> 
                                            <span>Package - {pack.pack_title}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            {pack.pack_price == 0 ? 
                                            <span style={{fontSize:14, color:"blue"}}>(1 Month)</span>
                                             : (
                                            <select className='form-select' name='type' 
                                                {...register("type", { required: true })}
                                            style={{width:"auto", fontSize:14, display:"inline-block", border:"1px solid #ccc", padding:"5px 15px"}}
                                                onChange={(e) => {
                                                    if (e.target.value === "1") {
                                                        setPrice(pack.pack_price);
                                                        let gst = pack.pack_price * 0.18;
                                                        setGst(gst);    
                                                        setTotal(pack.pack_price);
                                                    } else {
                                                        setPrice(pack.sell_price);
                                                        let total = pack.sell_price * 12;
                                                        let gst = total * 0.18;
                                                        setGst(gst);
                                                        setTotal(total);
                                                    }
                                                }}
                                            >
                                                <option value="1">Monthly</option>
                                                <option value="2">Yearly</option>
                                            </select>
                                            )}  
                                            {/* <span>₹{pack.sell_price}</span>
                                            <small>(per month)</small> */}
                                        </div>
                                        <div className='col-md-4 text-right'>
                                            {price == pack.sell_price && pack.sell_price > 0 ?
                                             <><strike style={{fontSize:13, color:"red"}}>₹{pack.pack_price}</strike><br /></> : ''}
                                            <span>₹</span><span>{price}</span>
                                        </div>
                                    </div>  
                                    {/* <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-6'>
                                            <span>{pack.pack_title}</span>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <span>₹</span><span>2000</span>
                                        </div>
                                    </div> */}

                                    <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-6'>
                                            <span>Subtotal</span>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <span>₹</span><span>{total}</span>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-6'>
                                            <span>GST</span>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <span>₹</span><span>{gst}</span>
                                        </div>
                                    </div>
                                    <div className='row' style={{borderTop: "1px solid #ddd"}}>
                                        <div className='col-md-6'>
                                            <h4>Total</h4>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <h4>₹{total+gst}</h4>
                                        </div>
                                    </div>
                                    <div className='row' style={{borderTop: "1px solid #ddd"}}>
                                        <div className='col-md-12'>
                                           <button type='submit' className='btn btn-outline-light try_free_btn' style={{width:'100%', padding:15, textAlign:"center"}} disabled={loading}>
                                               {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{marginRight:8}}></span>}
                                               {loading ? 'Processing...' : 'Proceed to payment'}
                                           </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    </div>
                </section>
               
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default CheckoutPage;